const STORAGE_KEY = 'soluqr_order_notes_v1';

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const o = JSON.parse(raw);
    return o && typeof o === 'object' ? o : {};
  } catch {
    return {};
  }
}

function writeAll(o) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(o));
}

export function readOrderNotes(businessId) {
  if (!businessId) return '';
  const o = readAll();
  return String(o[businessId] || '');
}

export function setOrderNotes(businessId, text) {
  if (!businessId) return;
  const o = readAll();
  o[businessId] = String(text ?? '');
  writeAll(o);
}

export function appendOrderNotes(businessId, line) {
  if (!businessId || !String(line || '').trim()) return;
  const cur = readOrderNotes(businessId).trim();
  const add = String(line).trim();
  const next = cur ? `${cur}\n${add}` : add;
  setOrderNotes(businessId, next);
}

export function clearOrderNotes(businessId) {
  if (!businessId) return;
  const o = readAll();
  delete o[businessId];
  writeAll(o);
}
